// extracted by mini-css-extract-plugin
module.exports = {"DetailsSkeleton":"DetailsSkeleton_DetailsSkeleton__3LoTQ","Item":"DetailsSkeleton_Item__3NKfr"};